import CategorySelect from "../CategorySelect/CategorySelect";
import TaxonomySelectPanelRow, {
  PANEL_TAXONOMY_SELECT_ID_PREFIX,
} from "../PanelRow/TaxonomySelectPanelRow";

import type { TransactionCategory } from "../../hooks/useTransactionCategories";

interface CategoryPanelRowProps {
  transaction: API.Transaction;
  categories: TransactionCategory[];
  canWrite: boolean;
}

const CategoryPanelRow = ({
  transaction,
  categories,
  canWrite,
}: CategoryPanelRowProps) => (
  <TaxonomySelectPanelRow
    categories={categories}
    canWrite={canWrite}
    labelId="live-ledger-panel-category-label"
    rowTestId="panel-category-row"
    textTestId="panel-category-text"
    text={transaction.category}
    select={
      <CategorySelect
        transaction={transaction}
        categories={categories}
        selectId={`${PANEL_TAXONOMY_SELECT_ID_PREFIX}category-${transaction.id}`}
      />
    }
  />
);

export default CategoryPanelRow;
